export const NBSP = '\u00a0';
